import { useCachedQuery } from '../../../../hooks/useCachedQuery';

// Imagens do paciente servidas pelo quarkus.
// Cache offline guarda apenas o metadata da lista (URLs/ids), não os bytes
// das imagens — os arquivos em si continuam vindo do servidor.
export function useImages(patientId) {
  const url = patientId ? `/images/patient/${patientId}` : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    images: data ?? [],
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
